import { IBookmarkEntry } from "../components/Bookmarks";
import { IFolder, IImage } from "./Images";
import { IChartList, IGroup, IPlayList, ITitle } from "./Music";
import { INews } from "./News";
import { ITankStation, ITankType } from "./Tanker";
import { IOrganization, ITask } from "./Timelog";

export interface IAppState {
  message: string;
  status: ISystemMessage[];
  loggedIn: boolean;
  time: Date;
  fontSize: number;
  bookmarks: IBookmarkEntry;
  env: {api: string, app: string};
  images: IImage[],
  folders: IFolder[],
  // media
  playList: ITitle[];      // playlist ready to play
  tracks: ITitle[],        // found tracks or loaded play list
  currentList: ITitle[],   // playlist for edit
  playLists: IPlayList[],  // saved playlists
  chartLists: IChartList[];     // tracks from a chart list
  groups: IGroup[],        // found group
  // users
  user: IUser;
  users: IUser[],
  isAvatar: boolean,
  tasks: ITask[],
  organizations: IOrganization[]
  subtitle: string;
  // news
  news: INews[];
  // common
  confirm: React.JSX.Element;
  pageCounter: number;
  mouseDown: boolean;
  fogg: boolean;
  pictures: IPicCategorie;
  keys: IKeys;
  threads: IThread[];
  settings: ISettings;
  tanker: {
    stations: ITankStation[];
    stationDetail: ITankStation,
    type: ITankType,
  }
}

export const noUser = {id: "", email: "", name: "", phone: "", rights: "user", readonly: true, hasToken: false, newsInfo: 0};

export interface ISystemMessage {
    msg: string;
    type: MessageType,
    timestamp?: number;
    read?: boolean;
}
export enum MessageType {
    success,
    error,
    hint,
    clear, 
};
export enum NewsInfo {
    "none" = 0,
    "push",
    "mail",
    "sms"
}
export interface IUser {
    id: string;
    name: string;
    email: string;
    phone: string;
    register?: Date;
    lastLogin?: Date;
    rights?: string;
    token?: string;
    passwd?: string;
    oldPass?: string;
    confirm?: string;
    readonly: boolean;
    hasToken: boolean;
    pushEnabled?: boolean;
    newsInfo: NewsInfo;
}
export enum DeviceType {
    small = "small",
    medium = "medium",
    large = "large",
}
export interface IUISettings {
    isMobile: boolean;
    deviceType: DeviceType;
    width: number;
    height: number;
    portrait: boolean;
    containerHeight: number;
    containerTop: number;
}
export enum BtnState {
    active,
    selected,
    inactive,
    wait,
    hide,
}
export interface IButtonState {
    button: string;
    label?: string;
    state?: BtnState;
    onClick?: () => void;
}
export interface IMenuItem {
    item: React.JSX.Element;
    onClick: (ev: any) => {};
    disabled: boolean;
}
export enum Rights {
    avatar,
    user,
    guest,
}
export interface IPicCategorie {
    [cat: string]:  {
        number: number,
        name: string,
        desc?: string,
        pic: IPicture[]
    };
}
export interface IPicture {
    id: number;
    name: string;
    thumb: string;
    cat: string;
}
export interface IKeys {
    left: number;
    right: number;
    esc: number;
}

export enum KeyCode {
    left,
    right,
    esc
}

export interface IMenu {
    title: string;
    link: string;
    selected: boolean;
}

export interface IThread {
    threadId: number;
    name: string;
    members: IMember[];
    thread: IChatMessage[];
    days?: string[];
}

export interface IThreadShort {
    threadId: number;
    name: string;
    members: IMember[];
} 

export interface IMember {
    userId: string;
    name: string;
    admin?: boolean;
}

export interface IChatMessage {
    id?: string;
    name?: string;
    timestamp: Date;
    message?: string;
    media?: boolean;
} 

export interface IThreadDay {
    day: string;
    cntMessages: number;
}
export interface ISettings {
    rights: string[];
}

export interface INewsInfoOption {
    [key: string]: {newsInfo: NewsInfo, label: string}; 
}